import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field } from 'redux-form';
import { Theme, colors } from 'hui/src/styled/theme';
import { ErrorText } from '../Field';

// TODO: These colors don't exist in HUI.
const lightGrey = '#D9DADA';

const RadioOption = styled.div`
  position: relative;
  input:checked + label {
    background-color: #f5f5f5;
    outline: none;
  }
  input:focus {
    outline: none;
  }
`;

// styling for the background
const Label = styled.label`
  cursor: pointer;
  color: ${colors.BLACK};
  text-decoration: none;
  text-align: left;
  font-size: 1em;
  display: block;
  width: 100%;
  padding: 1em 1em 1em 2.5em;
  margin-bottom: 0;
  border-bottom: 1px solid ${lightGrey};
`;

// styling for the checkmark
export const Input = styled(Field)`
  width: 1em;
  height: 1em;
  margin-right: 1em;
  margin-bottom: -2px;
  background-color: #fff;
  border: 1px solid ${Theme.greyMedium};
  border-radius: 100px;
  position: absolute;
  top: 17px;
  left: 15px;
  -webkit-appearance: none;
  & :checked {
    background-color: ${Theme.primary};
    border: 1px solid ${Theme.primary};
  }
`;

const errorMessage = (
  { meta } // eslint-disable-line
) => (meta.touched && meta.error ? <ErrorText>{meta.error}</ErrorText> : null);

export default function RadioButton({ options, name, stacked, onChange }) {
  return (
    <div>
      {options.map(({ value, label }) => {
        const key = `${name}_${value}`;
        return (
          <RadioOption key={key} stacked={stacked}>
            <Input
              type="radio"
              name={name}
              id={key}
              value={`${value}`}
              component={({ input, ...rest }) => {
                return (
                  <input
                    name={name}
                    {...input}
                    {...rest}
                    onChange={value => {
                      input.onChange(value);
                      onChange(value);
                    }}
                  />
                );
              }}
            />

            <Label key={key} htmlFor={key} stacked={stacked}>
              {label}
            </Label>
          </RadioOption>
        );
      })}
      <Field name={name} component={errorMessage} />
    </div>
  );
}

RadioButton.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string,
  stacked: PropTypes.bool,
  onChange: PropTypes.func
};
